'use client';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { ProductsSwiper } from '../../components/shared/products-swiper';
import { useRelatedProducts } from '@eliadmin/core/src/hooks/products/use-related-products';
import { RelatedProductsStatus } from '@eliadmin/core/src/components/product/detail/related-products-status';
export function ProductRelatedProducts({ slug }: { slug: string }) {
  const related = useRelatedProducts(slug);
  const products = related.products;
  if (!products.length && !related.isLoading && !related.isError) return null;
  return (
    <>
      {' '}
      {products.length > 0 && (
        <section
          className={cn(
            'custom-section',
            'border-t border-t-[#EBEBEB] pb-16 pt-8 sm:pb-20 sm:pt-10 lg:pb-24 lg:pt-12',
          )}
        >
          <ProductsSwiper title={'Podobné produkty'} products={products} hideButton />
        </section>
      )}{' '}
      <div className="mx-auto w-full max-w-screen-2xl px-4">
        <RelatedProductsStatus
          loading={related.isLoading}
          error={related.isError}
          retry={() => {
            void related.refetch();
          }}
        />
      </div>{' '}
    </>
  );
}
